import { Link } from 'react-router-dom'
import facebook from '../assets/icons/facebook.svg'
import instagram from '../assets/icons/instagram.svg'
import tiktok from '../assets/icons/tiktok.svg'
import youtube from '../assets/icons/youtube.svg'


const Footer = () => {
  return (
    <div className='bg-[#000000] pt-[80px] pb-[100px] border-gray border-t border-t-gray-700 text-white'>
      <div className='flex flex-wrap lg:flex-nowrap justify-between px-[50px] md:px-[100px] 2xl:px-[200px] pb-10'>
        <div className='mb-5 w-full lg:w-[25%]'>
          <Link to="/"><img src={require('../assets/imgs/logo.png')} className='h-[40px]' /></Link>
        </div>
        <div className='flex flex-col gap-2'>
          <h1 className='font-bold'>BUY, RENT AND SELL</h1>
          <Link to="/" className='opacity-75 font-medium'>Buy and sell properties</Link>
          <Link to="/" className='opacity-75 font-medium'> Rent home </Link>
          <Link to="/" className='opacity-75 font-medium'> Request an offer </Link>
          <Link to="/" className='opacity-75 font-medium'> Pricing </Link>
        </div>
        <div className='flex flex-col gap-2'>
          <h1 className='font-bold'>ABOUT</h1>
          <Link to="/" className='opacity-75 font-medium'>Company</Link>
          <Link to="/" className='opacity-75 font-medium'> How it works </Link>
          <Link to="/" className='opacity-75 font-medium'> Contact </Link>
        </div>
        <div className='flex flex-col gap-2'>
          <h1 className='font-bold'>TERMS & PRIVACY</h1>
          <Link to="/" className='opacity-75 font-medium'>Terms of Service </Link>
          <Link to="/" className='opacity-75 font-medium'> Privacy Policy </Link>
        </div>
        <div className='flex flex-col gap-2'>
          <h1 className='font-bold'>RESOURCES</h1>
          <Link to="/" className='opacity-75 font-medium'>Guides</Link>
          <Link to="/" className='opacity-75 font-medium'> FAQ </Link>
          <Link to="/" className='opacity-75 font-medium'> Help Center </Link>
        </div>
      </div>
      <div className='flex md:flex-row flex-col justify-between gap-5 px-[50px] md:px-[100px] 2xl:px-[200px] pt-10 md:flew-row'>
        <p className='opacity-75 font-medium md:text-left text-center'>© {new Date().getFullYear()} AK-JODEM. All rights reserved</p>
        <div className='flex justify-center md:justify-start gap-5 opacity-75'>
          <a href='https://www.facebook.com/share/1Kbi7WK22q/?mibextid=wwXIfr'><img src={facebook} alt='facebook icon' /></a>
          <a href='https://www.instagram.com/ak_jodem?igsh=azB3aW43cHdhMnpu'><img src={instagram} alt='instagram icon' /></a>
          <a href='https://www.tiktok.com/@ak.jodem?_t=ZS-8vQHBpiryCu&_r=1'><img src={tiktok} alt='tiktok icon' /></a>
          <a href='https://m.youtube.com/@Akjodem'><img src={youtube} alt='youtube icon' /></a>
        </div>
      </div>
    </div>
  )
}

export default Footer
